export const environment = {
  production: true,
  enableLogging: true,
  baseUrl: 'https://educare-apim-dev.azure-api.net/',
  baseUrlAuth: 'auth/api/',
  baseUrlPortal: 'portal/api/',
  recaptchSiteKey: '6LdZGPYpAAAAAK3wlrVrSGEyBX1o0IKRR5QyjvNc',
  knowledgeHubUrl: 'https://thepurehealth0.sharepoint.com/sites/StrategyAssist/SitePages/CollabHome.aspx',
  eventCutoffTimeInMinutes: 15,
  msalConfig: {
    clientId: '865bbb49-1f5b-4de6-8238-3d5283b10c47',
    authority: 'https://login.microsoftonline.com/9c79922d-8d78-4b6d-9f78-e58f9eb99d72',
    postLogoutRedirectUri: '/',
    apiScopes: ['https://PUREHEALTHADB2CEduCareDEV.onmicrosoft.com/865bbb49-1f5b-4de6-8238-3d5283b10c47/access_as_user']
  }
};
